module.exports = __webpack_public_path__ + "media/images/img_service_merit_3_3-7be745b20b0c275a2fe50b27cfdc530a.png";